import styles from './card.module.scss';
import React, {CSSProperties} from 'react';
import {Link} from 'react-router-dom';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    to?: string;
    outline?: boolean;
    gray?: boolean;
    arrow?: boolean | string;
    target?: string;
    style?: CSSProperties;
}

export function Card({children, to, outline, gray, arrow, target, style}: OwnProps) {
    if (to !== undefined) {
        return (
            <Link
                style={style}
                to={to}
                target={target}
                className={classNames(styles.card, {
                    [styles.card_outline]: outline,
                    [styles.card_gray]: gray,
                    [styles.card_arrow]: arrow !== undefined && arrow !== false,
                })}
                viewTransition={true}
            >
                {children}
                {arrow && <i className={typeof arrow === 'string' ? arrow : 'fa-light fa-chevron-right'} />}
            </Link>
        );
    }
    return (
        <div
            style={style}
            className={classNames(styles.card, {
                [styles.card_outline]: outline,
                [styles.card_gray]: gray,
                [styles.card_arrow]: arrow !== undefined && arrow !== false,
            })}
        >
            {children}
            {arrow && <i className={typeof arrow === 'string' ? arrow : 'fa-light fa-chevron-right'} />}
        </div>
    );
}
